import React from 'react';
import { useEffect, useState, useRef } from "react";
import NavButton from '../../homepage/header-banner/TopNavButton';
import ServerPricing from '../../homepage/header-banner/ServerPricing';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import CloudconsultCp from '../../homepage/consult/cloudconsult-cp';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import Sidebar from '../../container/Sidebar/Sidebar'
// import '../../container/Sidebar/sidebar.css'
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute"
import Contentcloudcard from "../../container/Card/Components/Contentcloudcard"
import Imagecloudcompute from "../../container/Card/Components/Imagecloudcompute"
import CardBoxRow from '../../container/Box/Components/CardBox-Row'
// import { MuiGrid } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CommonTable from '../../container/Table/Components/CommonTable';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../kubernetes/asset/css/style.css';
import '../../Style/typo.css'
import { Grid } from '@mui/material';
import Cloudconsult2 from '../../homepage/consult/cloudconsult-2';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import DividerComponent from '../../container/Divider/divider';
import styled from 'styled-components';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-vn';
import Cloudconsult2VN from '../../homepage/consult/cloudconsult-2-vn';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import HeaderVn from '../../detailpageVN/Page/component/headervn';
import FooterVn from '../../detailpageVN/Page/component/footervn';

const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;

const checkIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="12" height="12" fill="#7061ff"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" /></svg>`
// Titlecloudcompute
function KubeBenefitsVN() {
    const isMobile = useIsMobile();


    return (
        <Sysfont className='App'>
            <HeaderVn />
            <BannerPrivateCloudVN />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarVN />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("장점")} */}
                        {/* {Contentcloudcard(`Kubernetes 장점`)} */}

                        <MuiGrid item xs={12} sm={12}>{CardBoxRow(
                            "<p class='typo-21-sm typo-medium typo-black'>Những lợi ích khi sử dụng Kubernetes</p>",

                            `
                            <div class="kube-card-txt">
                                <ul>
                                    <li><p class='typo-14'>Dễ dàng triển khai cluster Kubernetes trên máy chủ nội bộ hoặc máy chủ riêng.</p></li>
                                    <li><p class='typo-14'>Khả năng điều phối công việc và tự động mở rộng tương tự như các nền tảng đám mây toàn cầu.</p></li>
                                    <li><p class='typo-14'>Kiến trúc linh hoạt, tối ưu theo mức sử dụng tài nguyên, không bị ràng buộc cố định.</p></li>
                                    <li><p class='typo-14'>Hỗ trợ tích hợp các công cụ giám sát và thu thập dữ liệu như Prometheus, Grafana.</p></li>
                                    <li><p class='typo-14'>Quản lý và lưu trữ dữ liệu hiệu quả cho cả workload có trạng thái và không trạng thái.</p></li>
                                    <li><p class='typo-14'>Hỗ trợ triển khai chính sách bảo mật nội bộ phù hợp cho doanh nghiệp.</p></li>
                                <ul>
                            </div>
                            <div class="kube-card-txt">
                                <ul>
                                    <li><p class='typo-14'>Tối ưu hóa việc sử dụng tài nguyên trên hạ tầng máy chủ.</p></li>
                                    <li><p class='typo-14'>Tự động mở rộng hệ thống (Autoscaling) theo nhu cầu sử dụng tài nguyên thực tế.</p></li>
                                    <li><p class='typo-14'>Đảm bảo dịch vụ hoạt động liên tục, hỗ trợ triển khai lại không gián đoạn.</p></li>
                                    <li><p class='typo-14'>Dễ dàng mở rộng cụm máy chủ và cân bằng tải hiệu quả.</p></li>
                                    <li><p class='typo-14'>Phù hợp với mô hình quản lý hạ tầng dựa trên kiến trúc Microservice.</p></li>
                                <ul>
                            </div>
                            `)}
                        </MuiGrid>
                        <DividerComponent />
                        <MuiGrid item xs={12} className='MuiGrid-card'>{Imagecloudcompute("https://hanbiro.com/assets/images/cloud/kube-node.png")}</MuiGrid>
                        <DividerComponent />
                        <Cloudconsult2VN />
                    </Col>
                </Row>
            </Container>


            {/* <Cloudconsult /> */}
            <FooterVn />
        </Sysfont>
    );
};

const MuiGrid = styled.div`
    padding: 0px,
`

export default KubeBenefitsVN;